<section class="breadcrumbs-wrap">
    <div class="btn-group">
        <div class="btn small outline-light" (click)="deselectSport()">Sport</div>
        <div class="btn small outline-light divider">></div>
        <div class="btn small outline-light" *ngIf="sport" (click)="deselectRegion()">{{sport.name}}</div>
        <div class="btn small outline-light divider" *ngIf="region">></div>
        <div class="btn small outline-light" *ngIf="region">{{region.name}}</div>
        <!-- <div class="btn small outline-light" *ngIf="competition">></div>
        <div class="btn small outline-light" *ngIf="competition">{{competition.name}}</div> -->
    </div>

    <div class="back btn primary small rounded" (click)="back()"><ng-container i18n="Back button@@BackButton">Nazad</ng-container></div>
</section>
